module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/aa3c3a337c60549f94f812e28b16b91b.png";